import { treeviaGateway } from '../clients/AxiosClients'

export const getAllDadosHistoricos = async () => {
	return await treeviaGateway.get('/ms-prognoses/BaseHistorica/recuperar-todas')
}

export const getMedicoesHistoricasByBaseHistoricaId = async (baseHistoricaId) => {
	return await treeviaGateway.get(
		`/ms-prognoses/MedicaoHistorica/recuperar-todas-vinculadas-a-base-historica/${baseHistoricaId}`,
	)
}

export const updateMedicao = async (medicaoHistorica) => {
	return await treeviaGateway.put(`/ms-prognoses/MedicaoHistorica`, medicaoHistorica)
}

export const updateBaseHistorica = async (baseHistorica) => {
	return await treeviaGateway.put(`/ms-prognoses/BaseHistorica`, baseHistorica)
}

export const createBaseHistorica = async (body) => {
	return await treeviaGateway.post(
		`/ms-prognoses/BaseHistorica/cadastrar-base-historica-com-medicoes-vinculadas`,
		body,
	)
}

export const deleteBaseHistoricaByIdList = async (baseHistoricaId) => {
	return await treeviaGateway.delete('/ms-prognoses/BaseHistorica/deletar-lista', {
		params: { baseHistoricaId },
		paramsSerializer: {
			indexes: null, // by default: false
		},
	})
}
